import React, { Component, createRef } from 'react'
import ProductLabel from './ProductLabel'
import { toJS } from 'mobx'

class ProductLabelsList extends Component {
	constructor(props) {
		super(props)
    this.state = { isExpanded: false, tagsMaxChars: 0 }
    this.wrapperRef = createRef()
	}

  componentDidMount() {
    window.addEventListener('resize', this.updateTagsMaxChars)
    this.updateTagsMaxChars()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateTagsMaxChars)
  }

  updateTagsMaxChars = () => {
    const wrapper = this.wrapperRef.current
    this.setState({ tagsMaxChars: Math.floor(wrapper.offsetWidth * 0.18) })
  }

	maxVisibleLayers() {
		var sum = 0, counter = 0
		let max = this.props.maxChars || this.state.tagsMaxChars

		for (var i = 0;(sum < max) && (i < this.props.labels.length); i++) {
			let item = this.props.labels[i]
			sum += item.name.length
			if (this.props.showLabelNumbers) {
				sum += (item.number || '').toString().length
			}
			if (sum <= max) counter += 1
		}
		return counter
	}

  reorderItems(tags, removeLabelTag) {
    const tagsByKind = { Instruments: [], Genres: [], Labels: [], Other: [] }
    tags.forEach(tag => {
      let kind = tagsByKind[tag.kind] ? tag.kind : 'Other'
      tagsByKind[kind].push(tag)
    })
    const { Instruments, Genres, Labels, Other } = tagsByKind
    return Instruments.concat(Genres).concat(removeLabelTag ? [] : Labels).concat(Other)
  }

  labelsToDisplay(maxVisible) {
    const { labels, removeLabelTag } = this.props
    const sorted = this.reorderItems(toJS(labels, { recurseEverything: true }), removeLabelTag)

    return sorted.slice(0, maxVisible)
  }

  toggleShowMore = (e) => {
    e.stopPropagation()

    this.setState({ isExpanded: !this.state.isExpanded })

    if (this.props.onToggle) {
      this.props.onToggle()
    }

    if (this.props.clickCallback) {
      this.props.clickCallback()
    } else {
      this.forceUpdate()
    }
	}

  capitalize(str) {
    return (str || '').split(' ')
      .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
      .join(' ')
  }

  onLabelToggle = (e) => {
    if (!this.state.isExpanded) this.toggleShowMore(e)
  }

  render() {
    var maxVisible = this.state.isExpanded ? this.props.labels.length : this.maxVisibleLayers()
    var left = this.labelsToDisplay(1000).length - maxVisible
    const { homeOnFiltersClear, active, showLabelNumbers, removeNonInstrumentTags } = this.props

		return (
			<div
        ref={this.wrapperRef}
        className={`flex flex-col ${this.props.className}`}
      >
        <div className='flex items-center flex-wrap gap-[3px]'>
          {
            this.labelsToDisplay(maxVisible).map((label, i) => (
              <ProductLabel
                key={i}
                number={showLabelNumbers && label.number}
                onToggle={this.onLabelToggle}
                homeOnFiltersClear={homeOnFiltersClear}
                removeNonInstrumentTags={removeNonInstrumentTags}
                yellowButton={false}
                active={active}
                uuid={label.uuid}
              >
                {this.capitalize(label.name)}
              </ProductLabel>
            ))
          }

          {
            !this.state.isExpanded && this.props.showOverflowNumber && left > 0 && (
              <span
                onClick={this.toggleShowMore}
                className={`font-bold cursor-pointer ${this.props.invertedTextColor ? 'text-gray-16' : 'text-gray-3'}`}
              >
                +&nbsp;{left}
              </span>
            )
          }

          {
            this.state.isExpanded && (
              <span
                onClick={this.toggleShowMore}
                className={`font-bold hidden ml-1.5 cursor-pointer md:inline-block ${this.props.invertedTextColor ? 'text-gray-16' : 'text-gray-3'}`}
              >
                -
              </span>
            )
          }
        </div>

        {
          this.state.isExpanded && this.props.showOverflowNumber && (
            <div className='flex justify-center'>
              <button
                type='button'
                onClick={this.toggleShowMore}
                className='px-4 border rounded-[30px] py-0.5 mt-5 cursor-pointer md:hidden'
              >
                Less
              </button>
            </div>
          )
        }
      </div>
		)
	}
}

export default ProductLabelsList
